import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Grid,
  MenuItem,
  Typography,
  Link,
  Card,
  CardContent,
  Tooltip,
  Dialog,
  DialogContent,
  DialogTitle,
  Popper,
  Box,
  Paper,
  LinearProgress,
  Autocomplete,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { setNotIsFirstAccess } from 'redux/notIsFirstAccess';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import moment from 'moment';
import './styles.css';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import PondDialogContent from './pondDialog/pondDialogContent';
import HelpIcon from '@mui/icons-material/Help';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { labelField } from 'utils';

function Cycle() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const [locale, setLocale] = React.useState('pt');
  const location = useLocation();
  const [ponds, setPonds] = useState([]);
  const time = new Date();
  const outraData = new Date();
  outraData.setDate(time.getDate() + 120);
  const [selectedBeginDate, handleBeginDateChange] = useState(null);
  const [selectedEndDate, handleEndDateChange] = useState(null);
  const [selectedPond, setSelectedPond] = useState(null);
  const [description, setDescription] = useState('1');
  const classes = useStyles();
  const [cyclesStatus, setCyclesStatus] = useState([]);
  const [idPond, setIdPond] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [openLinearProgress, setOpenLinearProgress] = useState(false);
  const [openPondModal, setOpenPondModal] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  let { id } = useParams();
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();

  const [user, setUser] = useState(null);

  useEffect(() => {
    async function ini() {
      setUser(await api.get('users'));
    }
    ini();
  }, []);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
        setSelectedPond(location.state.data.pond);
      } else if (location.state.pond) {
        formik.setFieldValue('pond', location.state.pond.id);
        setSelectedPond(location.state.pond);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    formik.setFieldValue('pond', data.pond.id);
    // Problema
    if (data.id !== null) {
      handleBeginDateChange(
        data.begin !== null
          ? moment(data.begin?.substring(0, 10), 'YYYY-MM-DD').toDate()
          : null
      );
      if (!data.end == null) {
        handleEndDateChange(new Date(data.end));
      }
      setSelectedPond(data.pond);
      setDescription(data.description);
    }
  }

  useEffect(() => {
    async function loadPonds() {
      setOpenProgress(true);
      try {
        const recPonds = await api.get(`/ponds/availables/${selectedCycle.id}`);
        if (
          selectedPond &&
          !recPonds.data.find((v) => v.id === selectedPond.id)
        ) {
          setSelectedPond(null);
        }
        setPonds([...recPonds.data].reverse());
      } catch (error) {
        // Handle error
      } finally {
        setOpenProgress(false);
      }
    }
    loadPonds();
  }, [selectedCycle, openPondModal]);

  useEffect(() => {
    // Prepara os dados para o componente DialogCicleViv
    async function getCycles() {
      const idRoute = id;
      if (idRoute === undefined && selectedPond) {
        const idSelectedPond = selectedPond.id;
        const cycles = await api.get('/cycles');
        const statusCycles = cycles.data.filter(
          (cycle) =>
            cycle.status === POND_STATUS_CYCLE.CULTIVANDO ||
            cycle.status === POND_STATUS_CYCLE.PREPARANDO
        );
        const cyclesPond = cycles.data.filter(
          (cycle) => cycle.pond === idSelectedPond
        );
        setCyclesStatus(statusCycles[0]);
        const cycleA = statusCycles.find(
          (cycle) => cycle.pond === idSelectedPond
        );
        const cycleB = cyclesPond.find(
          (cycle) => cycle.description === description
        );
        if (cycleB) setDialog(true);
        if (cycleA) setIdPond(true);
      }
    }
    getCycles();
    setDialog(false);
    setIdPond(false);
  }, [selectedPond, description]);

  const handleSuccess = () => {
    success();
    if (user.data.firstAccess) {
      api.put(`users/${user.data.id}`, {
        ...user.data,
        firstAccess: false,
      });
      dispatch(setNotIsFirstAccess(true));
    }
    history.push('/cycles');
  };

  const sendDataToAPI = async (data, id) => {
    try {
      id
        ? await api.put(`/cycles/${id}`, { ...data })
        : await api.post('/cycles', { ...data });
      handleSuccess();
    } catch (err) {
      error(err.response.data.message);
    }
  };

  async function request(data) {
    dispatch(setDisable(true));
    try {
      sendDataToAPI(data, id);
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      pond: '',
      cycleCode: selectedCycle,
      begin: '',
      end: '',
      population: 0,
      description: '',
      status: POND_STATUS_CYCLE.PREPARANDO,
      observation: '',
    },
    validationSchema: Yup.object({
      pond: Yup.number().required('Campo Obrigatório').nullable(),
      status: Yup.string().required('Campo Obrigatório'),
      population: Yup.number()
        .integer()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .typeError('O valor deve ser um número.')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua o tamanho da amostra'
        ),
      observation: Yup.string().max(
        100,
        'Máximo de caracteres ultrapassado (100 caracteres).'
      ),
    }),
    onSubmit: (values) => {
      dispatch(setLoading(true));
      values.begin =
        selectedBeginDate !== null
          ? moment(selectedBeginDate).format('YYYY-MM-DDT00:00:00[Z]')
          : null;
      values.end = selectedEndDate;
      values.pond = selectedPond.id;
      values.description = description;
      values.cycleCode = selectedCycle;
      request(values);
    },
  });

  useEffect(() => {
    if (formik.values.status === 'Concluído')
      handleEndDateChange(moment(Date.now()).format('YYYY-MM-DDT00:00:00[Z]'));
    else handleEndDateChange(null);
  }, [formik.values.status]);

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  /**
   * @param {React.ChangeEvent<{}>} event Parâmetro que mostra os eventos do DOM.
   * @param {AutocompleteChangeReason} reason
   */
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick') {
      setOpenPondModal(false);
    }
    if (reason === 'escapeKeyDown') {
      setOpenPondModal(false);
    }
  };

  return (
    <header className={styleGlobal.headerGlobal}>
      {/** Carregamento circular para o carregamento dos dados */}
      {openProgress ? <Progress /> : null}{' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem', paddingLeft: '1rem' }}>
              Dados do Viveiro no Ciclo{' '}
              <HtmlTooltip
                title={
                  <>
                    Essa tela possibilita que você inclua viveiros em um ciclo
                    de produção. Um ciclo se inicia com a preparação dos
                    viveiros para o povoamento e termina com a despesa.
                  </>
                }
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent>
              <Grid container spacing={2}>
                <Dialog
                  style={{ padding: '15rem' }}
                  open={openPondModal}
                  fullWidth
                  maxWidth="lg"
                  onClose={handleCloseModal}
                >
                  {openLinearProgress && <LinearProgress />}
                  <DialogTitle style={{ paddingBottom: '0' }}>
                    <span style={{ paddingLeft: '1rem' }}>
                      Dados do Viveiro
                    </span>
                  </DialogTitle>
                  <DialogContent>
                    <PondDialogContent
                      setOpenPondModal={setOpenPondModal}
                      setOpenAutocomplete={setOpenAutocomplete}
                      setOpenLinearProgress={setOpenLinearProgress}
                    />
                  </DialogContent>
                </Dialog>
                <Grid item xs={12} sm={!id ? 6 : 5}>
                  <FormGroup>
                    <Autocomplete
                      open={openAutocomplete}
                      onOpen={() => {
                        setOpenAutocomplete((state) => !state);
                      }}
                      onClose={() => {
                        setOpenAutocomplete((state) => !state);
                      }}
                      id="pond"
                      name="pond"
                      options={ponds}
                      value={selectedPond}
                      getOptionLabel={(options) => options.description}
                      onChange={(e, v) => {
                        setSelectedPond(v);
                        formik.values.pond = v?.id;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={!!(formik.touched.pond && formik.errors.pond)}
                          helperText={formik.touched.pond && formik.errors.pond}
                        />
                      )}
                      PopperComponent={(param) => (
                        <Popper {...param}>
                          <Box {...param} />
                          <Paper style={{ height: '100%' }}>
                            <Typography
                              style={{ padding: '1rem', color: 'gray' }}
                            >
                              {ponds.length === 0
                                ? 'A propriedade não possui nenhum viveiro cadastrado neste ciclo.'
                                : 'Deseja cadastrar outro viveiro?'}{' '}
                              <Link
                                style={{ cursor: 'pointer' }}
                                color="primary"
                                onMouseDown={() => {
                                  setOpenPondModal((state) => !state);
                                }}
                              >
                                Cadastrar Viveiro +
                              </Link>
                            </Typography>
                          </Paper>
                        </Popper>
                      )}
                    />
                  </FormGroup>
                </Grid>

                {id != null && (
                  <Grid item xs>
                    <FormGroup>
                      <TextField
                        disabled
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        id="status"
                        select
                        label="Status do ciclo"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        variant="outlined"
                        value={formik.values.status}
                        name="status"
                        // as="select"
                        error={
                          !!(formik.touched.status && formik.errors.status)
                        }
                        helperText={
                          formik.touched.status && formik.errors.status
                        }
                      >
                        <MenuItem key={1} value={POND_STATUS_CYCLE.PREPARANDO}>
                          {POND_STATUS_CYCLE.PREPARANDO}
                        </MenuItem>
                        <MenuItem key={2} value={POND_STATUS_CYCLE.CULTIVANDO}>
                          {POND_STATUS_CYCLE.CULTIVANDO}
                        </MenuItem>
                        <MenuItem key={3} value={POND_STATUS_CYCLE.DESPESCADO}>
                          {POND_STATUS_CYCLE.DESPESCADO}
                        </MenuItem>
                        <MenuItem key={4} value={POND_STATUS_CYCLE.TRANSFERIDO}>
                          {POND_STATUS_CYCLE.TRANSFERIDO}
                        </MenuItem>
                        <MenuItem key={5} value={POND_STATUS_CYCLE.CONCLUIDO}>
                          {POND_STATUS_CYCLE.CONCLUIDO}
                        </MenuItem>
                      </TextField>
                    </FormGroup>
                  </Grid>
                )}

                <Grid item xs sm={!id ? 6 : 'auto'}>
                  <FormGroup>
                    <NumberFormat
                      disabled
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="population"
                      fullWidth
                      label={
                        <div>
                          População atual
                          <HtmlTooltip
                            title={
                              <>População atual (quantidade de animais).</>
                            }
                            placement="top"
                            arrow
                          >
                            <HelpIcon color="primary" fontSize="inherit" />
                          </HtmlTooltip>
                        </div>
                      }
                      variant="outlined"
                      name="population"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      value={formik.values.population}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          population: values.floatValue,
                        });
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={
                        !!(
                          formik.touched.population && formik.errors.population
                        )
                      }
                      helperText={
                        formik.touched.population && formik.errors.population
                      }
                    />
                  </FormGroup>
                </Grid>

                {id ? (
                  <>
                    <Grid item xs>
                      <FormGroup>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale={locale}
                        >
                          <DatePicker
                            InputLabelProps={{
                              style: { pointerEvents: 'auto' },
                            }}
                            label="Data de início"
                            name="begin"
                            variant="inline"
                            inputVariant="outlined"
                            invalidDateMessage="Data Inválida"
                            value={selectedBeginDate}
                            onChange={(date) => handleBeginDateChange(date)}
                            onBlur={formik.handleBlur}
                            // inputFormat="DD/MM/YYYY"
                            format="dd/MM/yyyy"
                            fullWidth
                            error={
                              !!(formik.touched.begin && formik.errors.begin)
                            }
                            helperText={
                              formik.touched.begin &&
                              formik.errors.begin &&
                              formik.errors.begin
                            }
                            disabled
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </FormGroup>
                    </Grid>

                    <Grid item xs>
                      <FormGroup>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale={locale}
                        >
                          <DatePicker
                            disabled
                            InputLabelProps={{
                              style: { pointerEvents: 'auto' },
                            }}
                            InputProps={{ readOnly: true }}
                            label={
                              <div>
                                Data{' '}
                                <HtmlTooltip
                                  title={<>Data de conclusão.</>}
                                  placement="top"
                                  arrow
                                >
                                  <HelpIcon
                                    color="primary"
                                    fontSize="inherit"
                                  />
                                </HtmlTooltip>
                              </div>
                            }
                            name="end"
                            variant="inline"
                            inputVariant="outlined"
                            invalidDateMessage="Data Inválida"
                            value={selectedEndDate}
                            allowKeyboardControl={false}
                            onChange={(date) => handleEndDateChange(date)}
                            onBlur={formik.handleBlur}
                            // inputFormat="DD/MM/YYYY"
                            format="dd/MM/yyyy"
                            minDate={selectedBeginDate}
                            minDateMessage="A data de conclusão não deve ser anterior à data de inicio"
                            fullWidth
                            error={!!(formik.touched.end && formik.errors.end)}
                            helperText={formik.touched.end && formik.errors.end}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </FormGroup>
                    </Grid>
                  </>
                ) : null}

                <Grid item xs={12} sm={12}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="observation"
                      label="Observações (Opcional)"
                      variant="outlined"
                      name="observation"
                      type="text"
                      value={formik.values.observation || ''}
                      onChange={formik.handleChange}
                      onKeyDown={formik.handleBlur}
                      multiline
                      error={
                        !!(
                          formik.touched.observation &&
                          formik.errors.observation
                        )
                      }
                      helperText={
                        formik.touched.observation && formik.errors.observation
                      }
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </div>

          <section style={{ paddingInline: '1rem' }}>
            <GroupButton
              deleteRoute="/cycles/"
              routeDelete="/cycles"
              returnRoute="/cycles"
              id={id}
              disable={disable}
              messageDialogError
              // disableTemporary={true}
              message="A exclusão desse ciclo pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
            />
          </section>
        </form>
      </Card>
    </header>
  );
}

export default Cycle;
